/**
 * statusVariant(domain, status) -> 'grey' | 'blue' | 'amber' | 'green' | 'red'
 *
 * Traduit une valeur de statut metier en famille de couleur semantique.
 * Ne modifie jamais la valeur : c'est une couche d'affichage uniquement.
 *
 * `domain` permet de lever les ambiguites entre modules (un meme mot peut
 * avoir un sens different ailleurs). Si le domaine est inconnu ou si le
 * statut n'y figure pas, on retombe sur la table commune, puis sur 'grey'.
 */

// Table commune : sens partage par tous les domaines
const COMMON = {
  // pas commence
  draft: 'grey',
  to_assign: 'grey',
  new: 'grey',
  received: 'grey',
  open: 'grey',
  inactive: 'grey',

  // en cours / transmis
  submitted: 'blue',
  sent: 'blue',
  active: 'blue',
  in_review: 'blue',
  in_progress: 'blue',
  planning: 'blue',

  // en attente d'une action
  sent_for_approval: 'amber',
  to_resubmit: 'amber',
  pending: 'amber',
  pending_approval: 'amber',
  pending_signature: 'amber',
  partially_paid: 'amber',
  ready: 'amber',
  onhold: 'amber',
  'on-hold': 'amber',
  on_hold: 'amber',

  // termine
  approved: 'green',
  approved_to_pay: 'green',
  signed: 'green',
  paid: 'green',
  completed: 'green',
  answered: 'green',
  done: 'green',
  created: 'green',

  // arrete / en retard
  rejected: 'red',
  overdue: 'red',
  cancelled: 'red',
  canceled: 'red',
};

// Surcharges par domaine, uniquement quand le sens differe du commun
const BY_DOMAIN = {
  // La boite de reception : "created" = la depense a ete creee, c'est fini
  invoiceInbox: { new: 'grey', ready: 'amber', created: 'green' },
  // Le calendrier utilise des libelles anglais capitalises comme cles
  schedule: { open: 'grey', 'in progress': 'blue', done: 'green' },
  // Suivi de facturation d'une DP, a cote de son statut d'approbation
  billing: { not_invoiced: 'grey', invoiced: 'blue', paid: 'green' },
};

export const statusVariant = (domain, status) => {
  if (status === true) return 'green';
  if (status === false) return 'grey';
  const key = String(status ?? '')?.trim()?.toLowerCase();
  if (!key) return 'grey';
  return BY_DOMAIN?.[domain]?.[key] || COMMON?.[key] || 'grey';
};

export default statusVariant;
